<body>
  <app-nav-menu></app-nav-menu>
  <main class="flex flex-col justify-start p-2 min-h-screen bg-gray-50">
    <router-outlet></router-outlet>
  </main>
</body>
